const applyLimitType = "REPORT_AML_APPLY_CANDIDATES_LIMIT";
const expandType = "REPORT_AML_EXPAND_CANDIDATES";
const shrinkType = "REPORT_AML_SHRINK_CANDIDATES";

const applyLimit = (section, limit) => dispatch => { dispatch({ type: applyLimitType, section, limit }); };
const expand = (section) => dispatch => { dispatch({ type: expandType, section }); };
const shrink = (section) => dispatch => { dispatch({ type: shrinkType, section }); };

export const amlCandidatesActions = { applyLimit, expand, shrink };

const sectionNames = [ 'company', 'statutories', 'keyOwners', 'beneficialOwners', 'finalOwners', 'supervisoryBoard', 'publicFunctionsEval' ]

const sectionInitialState = {
    limit: 95,
    newLimit: 95,
    isExpanded: false
}

const initialState = {
    // apply the same initial state into all sections. 
    sections: sectionNames.reduce((constructingState, section) => { constructingState[section] = { ...sectionInitialState }; return constructingState; }, {})
}

// store reducer
export const reducer = (state, action) => {
    state = state || initialState;
    const currentSection = state.sections[action.section];
    switch(action.type){
        case applyLimitType:
            // store applied limit into 'newLimit' field because we do not want to see effects of this change right after this action as 
            // gui components only use 'limit' field.
            return updateSection(state, action, { newLimit: action.limit });
        case expandType:
            // expand section and also set 'newLimit' value into 'limit' value
            return updateSection(state, action, { isExpanded: true, limit: currentSection.newLimit });
        case shrinkType:
            // shrink section and set 'newLimit' value into 'limit' value only in case that this setting does not cause that more candidates
            // will be seen than before this action.
            return updateSection(state, action, { 
                isExpanded: false, 
                limit: (currentSection.isExpanded === true || currentSection.newLimit > currentSection.limit) ? currentSection.newLimit : currentSection.limit 
            });
        default:
            return state;
    }
}

const updateSection = (state, action, updatingObject) => {
    return { ...state, sections: { ...state.sections, [action.section]: { ...state.sections[action.section], ...updatingObject }}}
}

